(function ($) {
    "use strict";
    /*--document ready functions--*/
    jQuery(document).ready(function ($) {


    /*---------------------
        Cart Dropdown 
    --------------------- */
    var iconCart = $('.mini-cart-warp');
    iconCart.on('click', function() {
        $('.mini-cart-content').toggleClass('cart-visible');
    });
    /*---------------------
        Toggle Search Bar
    --------------------- */
    $(".search_list > a").on("click", function() {
        $(this).toggleClass('active');
        $('.dropdown_search').slideToggle('medium');
    }); 

 

    /*---------------------
        Mobile Menu Active
    --------------------- */
    $('#mobile-menu-active').meanmenu({
        meanScreenWidth: "991",
        meanMenuContainer: ".mobile-menu",
    });
    


      
      // Section with Editor
      $(document).on('shopify:section:load', function(e){ 
        $('#' + e.target.id).find('[data-section]').sectionJs();
      }).ready(function() {
        $('[data-section]').each(function(){ $(this).sectionJs() });
      });

      
      $.fn.sectionJs = function(){
        var $this = this;
        if($this.data('section') == "CategoriesSlider") {
          $this.find('.category-slider').CategoriesSlider();
        }else if($this.data('section') == "FeatureDealColl") {
          $this.find('.new-product-slider').NewProSlider();
          $this.find('.hot-deal').HotDealColl();
        }else if($this.data('section') == "FeatureSliderPro") {
          $this.find('.feature-slider').FeatureSliderPro();
        }else if($this.data('section') == "BlogSliderActive") {
          $this.find('.blog-slider-active').BlogSliderActive();
        }else if($this.data('section') == "TabProductSlider") {
          $this.find('.tab-product-slider ').TabProductSlider();
        }else if($this.data('section') == "heroOwlSlider") {
          $this.heroOwlSlider();            
        }else{} 

      }
      

    /*==============All Slick Slider ==================*/
    $.fn.CategoriesSlider = function() {
      var $CategoriesSliderVAR = this;
      $CategoriesSliderVAR.slick({
        infinite: true
      });
    };
        
    /* Product dec slider */
    $.fn.NewProSlider = function() {
      var $NewProSliderVAR = this;
      $NewProSliderVAR.slick({
        infinite: true,
        slidesToScroll: 1,
      });
    };
      
                  
      /* Product dec slider */
    $.fn.HotDealColl = function() {
      var $HotDealCollVAR = this;
      $HotDealCollVAR.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    };
      
      /* Product dec slider */
      $.fn.FeatureSliderPro = function() {
        var $FeatureSliderProVAR = this;
        $FeatureSliderProVAR.slick({
          infinite: true,
        });
      };
      
      /* Product dec slider */
      $.fn.FeatureSliderPro = function() {
        var $FeatureSliderProVAR = this;
        $FeatureSliderProVAR.slick({
          infinite: true,
        });
      };
      
      /* Product dec slider */
      $.fn.BlogSliderActive = function() {
        var $BlogSliderActiveVAR = this;
        $BlogSliderActiveVAR.slick({
          infinite: true,
        });
      };
      
      /* Product dec slider */
      $.fn.TabProductSlider = function() {
        var $TabProductSliderVAR = this;
        $TabProductSliderVAR.slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          rows:2
        });
      };

    /*==============All Owl Slider ==================*/
    $.fn.heroOwlSlider = function(){

      // Variable
      var $carousel = $('[data-owl-carousel]');      
      var $heroSlider = $('.slider-active-3');
      var $BrandSlider = $('.brand-slider');
      var $TestiSlider = $('.testi-slider');
      
      // Owl Carousel Options
      if ($carousel.length) {
        $carousel.each(function() {
          $(this).owlCarousel($(this).data('owl-carousel'));
        });
      }

      //Hero Fluid Slider Activation
      $heroSlider.owlCarousel();
      $BrandSlider.owlCarousel();
      $TestiSlider.owlCarousel();

    };

    


    /*---------------------
        Main Slider Active
    --------------------- */
      
      var $slider_home_16 = $('.slider-home-16');
      if($slider_home_16.length > 0){
        $slider_home_16.owlCarousel({
          loop: true,
          nav: true,
          dots:false,
          autoplay: true,
          autoplayTimeout: 5000,
          animateOut: 'fadeOut',
          animateIn: 'fadeIn',
          item: 1,
          responsive: {
            0: {
              items: 1
            },
            768: {
              items: 1
            },
            1000: {
              items: 1
            }
          }
        });
      }
      

    /*---------------------------
       Best Sell Slider Active
    ------------------------------ */
      
      var $best_sell_slider = $('.best-sell-slider');
      if($best_sell_slider.length > 0){
        $best_sell_slider.owlCarousel({

          autoplay :   false,
          loop: false,
          smartSpeed : 1000,
          nav :  true ,
          dots :  false ,
          margin:30,
          responsive:{
            0:{
              items:1,
              autoplay: true,
              loop: true,
            },
            360:{
              items:1,
              autoplay: true,
              loop: true,
            },
            500:{
              items:2,
              autoplay: true,
              loop: true,

            },
            768:{
              items:3,
            },
            992:{
              items:4,
            },
            1200:{
              items:5,
            }
          }
        });
      }


      /*---------------------------
       Best Sell Slider 2 Active
    ------------------------------ */

      var $best_sell_slider_2 = $('.best-sell-slider-2');
      if($best_sell_slider_2.length > 0){
        $best_sell_slider_2.owlCarousel({

          autoplay :   false,
          loop: false,
          smartSpeed : 1000,
          nav :  true ,
          dots :  false ,
          margin:0,
          responsive:{
            0:{
              items:1,
              autoplay: true,
              loop: true,
            },
            360:{
              items:1,
              autoplay: true,
              loop: true,
            },
            500:{
              items:2,
              autoplay: true,
              loop: true,

            },
            768:{
              items:3,
            },
            992:{
              items:4,
            },
            1200:{
              items:5,
            }
          }
        });
      }



      /*---------------------------
       New Product Slider Active
    ------------------------------ */
      var $new_product_slider_2 = $('.new-product-slider-2');
      if($new_product_slider_2.length > 0){
        $new_product_slider_2.owlCarousel({

          autoplay :   false,
          smartSpeed : 1000,
          nav :  true ,
          loop: false,
          dots :  false ,
          items:4,
          margin:0,
          responsive:{
            0:{
              items:1,
              autoplay: true,
              loop: true,
            },

            360:{
              items:1,
              autoplay: true,
              loop: true,
            },
            500:{
              items:2,
              autoplay: true,
              loop: true,

            },
            768:{
              items:2,
            },
            992:{
              items:2,
            },
            1024:{
              items:2,
            },
            1200:{
              items:3,
            },
            1300:{
              items:4,
            }
          }
        });
      }






      /*----------------------------------
       Feature Product Slider 2 Active
    ------------------------------------ */
      var $feature_slider_2 = $('.feature-slider-2');
      if($feature_slider_2.length > 0){
        $feature_slider_2.owlCarousel({
          autoplay :   false,
          nav :  true ,
          smartSpeed : 1000,
          dots :  false ,
          items:2,
          loop:false,
          margin:30,
          responsive:{
            0:{
              items:1,
              autoplay: true,
              loop: true,
            },
            360:{
              items:1,
              autoplay: true,
              loop: true,
            },
            576:{
              items:1,
              autoplay: true,
              loop: true,

            },
            768:{
              items:2,
            },
            992:{
              items:2,
            },
            1000:{
              items:1,
            },
            1200:{
              items:1,
            },
            1300:{
              items:2,
            }
          }
        });
      }

      /*---------------------------
       Feature Product Slider Active
    ------------------------------ */
      var $feature_slider_3 = $('.feature-slider-3');
      if($feature_slider_3.length > 0){
        $feature_slider_3.owlCarousel({
          autoplay :   false,
          smartSpeed : 1000,
          nav :  true ,
          loop: false,
          dots :  false ,
          items:3,
          margin:0,
          responsive:{
            0:{
              items:1,
              autoplay: true,
              loop: true,
            },
            360:{
              items:1,
              autoplay: true,
              loop: true,
            },
            576:{
              items:1,
              autoplay: true,
              loop: true,

            },
            768:{
              items:2,
            },
            992:{
              items:3,
            },
            1200:{
              items:3,
            },
            1300:{
              items:3,
            },
          },
        });
      }


    /*---------------------------
     Hot Deal Slider 2 Active
    ------------------------------ */
      
      var $hot_deal_2 = $('.hot-deal-2');
      if($hot_deal_2.length > 0){
        $hot_deal_2.owlCarousel({ 
          autoplay :   false,
          nav :  true ,
          smartSpeed : 1000,
          dots :  false ,
          items:2,
          loop:false,
          margin:30,
          responsive:{
            0:{
              items:1,
              autoplay: true,
              loop: true,
            },
            360:{
              items:1,
              autoplay: true,
              loop: true,
            },
            576:{
              items:1,
              autoplay: true,
              loop: true,

            },
            768:{
              items:1,
            },
            992:{
              items:1,
            },
            1200:{
              items:2,
            }
          }
        });
      }


    

    /*--------------------------------
       Category Product Slider Active
    ---------------------------------- */
      
      var $category_product_slider = $('.category-product-slider');
      if($category_product_slider.length > 0){
        $category_product_slider.owlCarousel({ 
     
            autoplay :   false,
            smartSpeed : 1000,
            nav :  true ,
            loop: false,
            dots :  false ,
            items:4,
            margin:30,
            responsive:{
                0:{
                    items:1,
                    autoplay: true,
                    loop: true,
                },
                360:{
                    items:1,
                    autoplay: true,
                    loop: true,
                },
                576:{
                    items:1,
                    autoplay: true,
                    loop: true,
    
                },
                768:{
                    items:2,
                },
                992:{
                    items:1,
                },
                1200:{
                    items:1,
                }
            }
    });
      }

    /*--------------------------------
       Category Product Slider Active
    ---------------------------------- */
            
      var $single_product_slider_active = $('.single-product-slider-active');
      if($single_product_slider_active.length > 0){
        $single_product_slider_active.owlCarousel({ 
      
            autoplay :   false,
            smartSpeed : 1000,
            nav :  true ,
            loop: true,
            dots :  false ,
            items:4,
            margin:30,
            responsive:{
                0:{
                    items:1,
                    autoplay: true,
                    loop: true,
                },
                360:{
                    items:1,
                    autoplay: true,
                    loop: true,
                },
                576:{
                    items:2,
                    autoplay: true,
                    loop: true,
    
                },
                768:{
                    items:3,
                },
                992:{
                    items:3,
                },
                1200:{
                    items:4,
                }
            }
    });
      }


      /*--------------------------------
       Category Product Slider Active
    ---------------------------------- */
      var $category_product_2 = $('.category-product-2');
      if($category_product_2.length > 0){
        $category_product_2.owlCarousel({ 

          autoplay :   false,
          smartSpeed : 1000,
          nav :  true ,
          loop: false,
          dots :  false ,
          items:1,
          margin:30,
          responsive:{
            0:{
              items:1,
              autoplay: true,
              loop: true,
            },
            360:{
              items:1,
              autoplay: true,
              loop: true,
            },
            576:{
              items:1,
              autoplay: true,
              loop: true,

            },
            768:{
              items:1,
            },
            992:{
              items:1,
            },
            1200:{
              items:1,
            }
          }
        });
      }



    
    /*---------------------
        Product dec slider
    --------------------- */
      
      
      var $product_dec_slider_2 = $('.product-dec-slider-2');
      if($product_dec_slider_2.length > 0){
        $product_dec_slider_2.slick({
        infinite: true,
        slidesToShow: 4,
        arrows:false,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 992,
                Settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                Settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 479,
                Settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    	});
      }
      
    /*---------------------
        Product dec slider
    --------------------- */
      var $product_dec_slider_3 = $('.product-dec-slider-3');
      if($product_dec_slider_3.length > 0){
        $product_dec_slider_3.slick({

        infinite: true,
        slidesToShow: 4,
        arrows:false,
        vertical: true,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 992,
                Settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                Settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 479,
                Settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
      }
    /*---------------------------
       Blog Gallery Slider Active
    ------------------------------ */

      var $blog_gallery = $('.blog-gallery');
      if($blog_gallery.length > 0){
        $blog_gallery.slick({
          dots: false,
          infinite: true,
          arrows: true,
          prevArrow:'<span class="prev"><i class="ion-ios-arrow-left"></i></span>',
          nextArrow: '<span class="next"><i class="ion-ios-arrow-right"></i></span>',
          speed: 800,
          slidesToShow: 1,
          slidesToScroll: 1,
        });
      }

    /*---------------------------
       Quick view Slider Active
    ------------------------------ */
      var $quickview_slider_active = $('.quickview-slide-active');
      if($quickview_slider_active.length > 0){
        $quickview_slider_active.owlCarousel({ 
          loop: false,
          margin: 15,
          smartSpeed: 1000,
          nav: true,
          dots: false,
          responsive: {
            0: {
              items: 3,
              autoplay: true,
              smartSpeed: 300
            },
            576: {
              items: 3
            },
            768: {
              items: 3
            },
            1000: {
              items: 3
            }
          }
        });
      }
    
    
    $('.quickview-slide-active a').on('click', function() {
        $('.quickview-slide-active a').removeClass('active');
    })
    
      /*--------------------------
        ScrollUp
    ---------------------------- */
    $.scrollUp({
        scrollText: '<i class="fa fa-arrow-up"></i>',
        easingType: 'linear',
        scrollSpeed: 900,
        animation: 'fade'
    });
    


    


  /*-------------------------
    Create an account toggle
    --------------------------*/
    $('.checkout-toggle2').on('click', function() {
        $('.open-toggle2').slideToggle(1000);
    });
    
    $('.checkout-toggle').on('click', function() {
        $('.open-toggle').slideToggle(1000);
    });

    
    $('.vertical-menu-toggle').on('click', function() {
        $('.open-menu-toggle').slideToggle(500);
    });

     /*--------------------  
     Category more toggle  
     ----------------------*/

      $(".vertical-menu li.hidden").hide();
      $("#more-btn").on('click', function (e) {

        e.preventDefault();
        $(".vertical-menu li.hidden").toggle(500);
        var htmlAfter = '<i class="ion-ios-plus-empty" aria-hidden="true"></i> More Categories';
        var htmlBefore = '<i class="ion-ios-minus-empty" aria-hidden="true"></i> Less Categories';


        if ($(this).html() == htmlBefore) {
          $(this).html(htmlAfter);
        } else {
          $(this).html(htmlBefore);
        }
      });

      
      $(".mobile_ctg_menu li.hidden").hide();
      $("#more-btn2").on('click', function (e) {

        e.preventDefault();
        $(".mobile_ctg_menu li.hidden").toggle(500);
        var htmlAfter = '<i class="ion-ios-plus-empty" aria-hidden="true"></i> More Categories';
        var htmlBefore = '<i class="ion-ios-minus-empty" aria-hidden="true"></i> Less Categories';


        if ($(this).html() == htmlBefore) {
          $(this).html(htmlAfter);
        } else {
          $(this).html(htmlBefore);
        }
      });
      

     /*--------------------  
     All Category toggle  
     ----------------------*/

        $(".category-toggle").click(function(){
            $(".category-menu").slideToggle("slow");
          });
        $(".menu-item-has-children-1").click(function(){
            $(".category-mega-menu-1").slideToggle("slow");
          });
        $(".menu-item-has-children-2").click(function(){
            $(".category-mega-menu-2").slideToggle("slow");
          });
        $(".menu-item-has-children-3").click(function(){
            $(".category-mega-menu-3").slideToggle("slow");
          });
        $(".menu-item-has-children-4").click(function(){
            $(".category-mega-menu-4").slideToggle("slow");
          });
        $(".menu-item-has-children-5").click(function(){
            $(".category-mega-menu-5").slideToggle("slow");
          });
        $(".menu-item-has-children-6").click(function(){
            $(".category-mega-menu-6").slideToggle("slow");
          });


    /*---------------------
        Countdown
    --------------------- */
    $('[data-countdown]').each(function() {
        var $this = $(this),
            finalDate = $(this).data('countdown');
        $this.countdown(finalDate, function(event) {
            $this.html(event.strftime('<span class="cdown day">%-D <p>Days</p></span> <span class="cdown hour">%-H <p>Hours</p></span> <span class="cdown minutes">%M <p>Mins</p></span> <span class="cdown second">%S <p>Sec</p></span>'));
        });
    });
      

   

    /*---------------------------
       Menu Fixed On Scroll Active
    ------------------------------ */
  $(window).scroll(function () {
    var window_top = $(window).scrollTop() + 1;
    if (window_top > 50) {
      $('.sticky-nav').addClass('menu_fixed animated fadeInDown');
    } else {
      $('.sticky-nav').removeClass('menu_fixed animated fadeInDown');
    }
  });
   
    /*---------------------------
       Window On Load Functions Active
    ------------------------------ */
    
      $(window).on('load', function(event) {
        $('#preloader').delay(500).fadeOut(500);
    });


  
  
  
  
  // Product grid color variant activation code. 
  $('.product-color li label').click(function(){
    var variantImage = jQuery(this).parent().find('.hidden a').attr('href');
    jQuery(this).parents('.product-wrapper-class').find('.popup_cart_image').attr({ src: variantImage }); 
    return false;
  });

  });
  
 

}(jQuery)); 
